export default {
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    buttons: {
      type: Array,
      required: false,
      default() {
        return [
          {
            name: "reset",
            type: "reset",
            text: "取消",
          },
          {
            name: "submit",
            type: "submit",
            text: "确认",
          },
        ];
      },
    },
    buttonsAlign: {
      type: String,
      required: false,
      default: "left",
    },
  },
  methods: {
    onClick(type, callback = () => {}) {
      if (type === "submit") {
        this.$emit("onSubmit", callback);
      } else if (type === "reset") {
        this.$emit("onReset", callback);
      } else {
        callback(type);
      }
    },
    getButtonType(type) {
      if (type === "submit") {
        return "primary";
      } else {
        return "default";
      }
    },
  },
  render() {
    return (
      <el-form-item
        label-width={this.buttonsAlign === "center" ? "0" : undefined}
        style={`text-align:${this.buttonsAlign}`}
      >
        {this.buttons.map((item) => {
          return (
            <el-button
              type={this.getButtonType(item.type)}
              loading={item.type === "submit" && this.loading}
              disabled={item.type === "reset" && this.loading}
              onClick={() => this.onClick(item.type, item.onClick)}
              data-cy={item.name || item.type}
            >
              {item.text}
            </el-button>
          );
        })}
      </el-form-item>
    );
  },
};
